/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query ScriptReadQuery(
    $scriptId: ID
    $search: String
    $skip: Int
    $take: PositiveInt
    $filter: JSONObject
  ) {
    ScriptRead(
      scriptId: $scriptId
      search: $search
      skip: $skip
      take: $take
      filter: $filter
    ) {
      id
      name
      scriptCode
      _totalCount
      createdAt
      status
      message
    }
  }
`;
